export const INSPECTION_AUTHORITY_TYPES = [
  { label: "City", value: "City" },
  { label: "3rd Party", value: "ThirdParty" },
];
